module.exports = __webpack_public_path__ + "assets/f2994af4d3b917f08e734e6d17fda16a.png";